import { render, staticRenderFns } from "./CustomArticleFieldsView.vue?vue&type=template&id=04813bfb"
import script from "./CustomArticleFieldsView.ts?vue&type=script&lang=ts&external"
export * from "./CustomArticleFieldsView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports